import Box from '@mui/material/Box';
import * as Icon from '@mui/icons-material/';
import ComponentTable from '../../../Components/Table/Index';
import { Loader } from '../../../../shared/components/Loader';
import useMaquinaPesquisar from '../../../../hooks/useMaquinaPesquisar';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import FormBuilder from '../../../../shared/components/FormBuilder';
import { OPTIONS_TIPO_MAQUINA_FILTRO } from '../../../../shared/utils/const/TipoMaquinaOptions';

export default function Maquina() {
  const {
    handleNavigation,
    handleSubmit,
    initialValues,
    loading,
    tableColumns,
    tableRows,
    handleEditItem,
  } = useMaquinaPesquisar();

  const fields = [
    { name: 'Marca', label: 'Marca', type: 'text', col: 3 },
    { name: 'Modelo', label: 'Modelo', type: 'text', col: 3 },
    { name: 'NumeroSerie', label: 'Número Série', type: 'text', col: 3 },
    { name: 'TipoMaquina', label: 'Tipo', type: 'select', options: OPTIONS_TIPO_MAQUINA_FILTRO, col: 2 },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />), col: 1 }
  ]

  return (
    <Loader loading={loading}>
      <Box>
        <HeaderComponent
          text={'Pesquisar Maquina'}
          ButtonRight={
            <Button
              className={''}
              variant='success'
              onClick={handleNavigation}
              iconStart={<Icon.Add />}
              title={'Incluir'}
            />
          }
        />
        <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} gap='gap-3' />
        <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);}}/>
      </Box>
    </Loader>
  );
}
